import { render, staticRenderFns } from "./MobileCoverPopup.vue?vue&type=template&id=1b45ca4f&scoped=true&"
import script from "./MobileCoverPopup.vue?vue&type=script&lang=js&"
export * from "./MobileCoverPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b45ca4f",
  null
  
)

export default component.exports